import PropTypes from 'prop-types'
import { isNil } from 'ramda'

class ContactsV2 {
  constructor(init) {
    // console.log('> ContactsV2 constructor -', init)
    if (isNil(init)) return undefined
    this._address = init.address
    this._address_line_1 = init.address_line_1
    this._address_line_2 = init.address_line_2
    this._city = init.city
    this._confidence = init.confidence
    this._distance = init.distance
    this._name = init.name
    this._phone = init.phone
    this._rightway_primary = init.rightway_primary
    this._state = init.state
    this._street = init.street
    this._latitude = init.latitude
    this._longitude = init.longitude
    this._uuid = init.uuid
    this._zip = init.zip
  }

  static shape = {
    address: PropTypes.string,
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    city: PropTypes.string,
    confidence: PropTypes.number,
    distance: PropTypes.number,
    name: PropTypes.string,
    phone: PropTypes.string,
    rightway_primary: PropTypes.bool,
    state: PropTypes.string,
    street: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    uuid: PropTypes.string,
    zip: PropTypes.string
  }

  get address() {
    return this._address || ''
  }

  get address_line_1() {
    return this._address_line_1 || ''
  }

  get address_line_2() {
    return this._address_line_2 || ''
  }

  get city() {
    return this._city || ''
  }

  get confidence() {
    return this._confidence || 0
  }

  get distance() {
    return this._distance
  }

  get name() {
    return this._name || ''
  }

  get phone() {
    return this._phone || ''
  }

  get rightway_primary() {
    return this._rightway_primary || false
  }

  get state() {
    return this._state || ''
  }

  get street() {
    return this._street || ''
  }

  get latitude() {
    return this._latitude
  }

  get longitude() {
    return this._longitude
  }

  get uuid() {
    return this._uuid || ''
  }

  get zip() {
    return this._zip || ''
  }
}

export default ContactsV2
